<template>
  <div class="promo-design-group">
    <div v-if="deviceType === 'android_os' || deviceType === 'android_tv'">
      <v-text-field
        v-model="actions.rf_settings_android_inapp_product_id"
        variant="outlined"
        density="compact"
        label="Android Product Id"
        hideDetails
        placeholder="Enter product Id"
      />
    </div>
    <div v-if="deviceType === 'ios' || deviceType === 'tv_os'">
      <v-select
        v-if="appleActive"
        v-model="actions.rf_settings_apple_inapp_product_id"
        variant="outlined"
        density="compact"
        persistentPlaceholder
        placeholder="Select product Id"
        :items="appleProductIds"
        label="Apple Product Id"
        itemTitle="text"
      />
      <div v-else>
        Apple connector is not active. Visit
        <router-link :to="actionsLink">connector settings</router-link> to activate.
      </div>
    </div>
    <div v-if="deviceType === 'roku_os'" class="promo-timer-setting">
      <v-text-field
        v-model="actions.rf_settings_roku_product_id"
        variant="outlined"
        density="compact"
        persistentPlaceholder
        label="Roku Product Id"
        hideDetails
        placeholder="Enter product Id"
      />
      <v-select
        v-model="actions.rf_settings_roku_product_operation"
        variant="outlined"
        density="compact"
        placeholder="Select Operation"
        label="Product Operation"
        itemTitle="text"
        :items="operations"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "RfRetentionActionsInApp",
  props: {
    actions: { type: Object, default: () => ({}) },
    app: { type: Object, default: () => ({}) },
    deviceType: { type: String, default: "android_os" },
  },
  data: () => ({ operations: ["Upgrade", "Downgrade", { text: "None", value: "" }] }),
  computed: {
    appleActive() {
      return this.app.providers.apple.active;
    },
    appleProductIds() {
      return this.app.providers.apple.product_ids.map(item => {
        return { value: item.product_id, text: item.name };
      });
    },
    actionsLink() {
      return {
        path: `/apps/${this.app.id}/settings/connectors`,
      };
    },
  },
};
</script>
